var React = require('react');

function V2Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.5 0C1.567 0 0 1.567 0 3.5V14.5C0 16.433 1.567 18 3.5 18H20.5C22.433 18 24 16.433 24 14.5V3.5C24 1.567 22.433 0 20.5 0H3.5ZM3 5.34929V14.5C3 14.7761 3.22386 15 3.5 15H20.5C20.7761 15 21 14.7761 21 14.5V5.34929L14.8297 9.05145C13.088 10.0965 10.912 10.0965 9.17027 9.05145L3 5.34929ZM19.0845 3H4.91548L10.7138 6.47897C11.5055 6.95399 12.4945 6.95399 13.2862 6.47897L19.0845 3Z"}));
}

V2Email.defaultProps = {"width":"24","height":"18","viewBox":"0 0 24 18","fill":"current","stroke":"current"};

module.exports = V2Email;

V2Email.default = V2Email;
